import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

//reducers
import { default as amaliatReducer, default as privilegeReducer } from "./slices/amaliatSlice";
import blogReducer from "./slices/blogSlice";
import counterReducer from "./slices/counter";
import notificationReducer from "./slices/notificationUi";

const reducers = combineReducers({
  counter: counterReducer,
  message: notificationReducer,
  blog: blogReducer,
  privileges: privilegeReducer,
  amaliat: amaliatReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "privileges"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});
